import { jsx as i } from "react/jsx-runtime";
import { LoggerLevels as a } from "../../../utils/enums.js";
import { idsLogger as l } from "../../../utils/helpers.js";
import { IressSelectOption as s } from "../components/SelectOption.js";
const d = (r) => (l(
  "IressSelect: mapSelectOptions has been deprecated and will be removed in a future version of IDS, please map and render the items array directly in your application instead.",
  a.Warn
), !r || !r.length ? null : r.map((e, t) => m(e, t))), m = ({ children: r, label: e, onClick: t, testId: o, value: p }, n) => r ? /* @__PURE__ */ i("optgroup", { label: String(e), children: d(r) }, n) : /* @__PURE__ */ i(
  s,
  {
    onClick: t,
    "data-testid": o ? `${o}` : void 0,
    value: p,
    children: e
  },
  n
);
export {
  d as mapSelectOptions,
  m as renderOptionOrOptGroup
};
